export default "__VITE_ASSET__FByy_4KO__"